export default __webpack_public_path__ + "static/media/damacaimobile.bbc122b9.png";